import { Replay } from '@material-ui/icons'
import React from 'react'
import Text from '../Text'
import Button from './Button'

const ReloadButton = ({
    message = 'Please check your internet connection or login again.',
    handleOnClick
}) => {
    return (
        <>
            <Text
                variant="h3"
                ascent="primary"
            >{message}</Text>
            <Button onClick={handleOnClick} style={{ marginTop: '1rem' }}>Reload <Replay /></Button>
        </>
    )
}

export default ReloadButton
